const config = {
  baseURL: void 0
};
const URI_PROTOCOL = /^https?:/;
function isFullUri(apiKey) {
  return /^\/\//.test(apiKey) || URI_PROTOCOL.test(apiKey);
}
function isRelativeUri(apiKey) {
  return apiKey.charAt(0) === "/";
}
function checkBaseURL(baseURL) {
  if (typeof baseURL !== "string") {
    throw new Error(`[Http Exception] baseURL must be string, but now: ${baseURL}`);
  }
  if (baseURL.charAt(baseURL.length - 1) === "/") {
    throw Error('[Http Exception] baseURL should not end with "/"');
  }
}
function configure({ baseURL } = {}) {
  if (baseURL) {
    checkBaseURL(baseURL);
    if (typeof config.baseURL !== "undefined") {
      console.warn("[Http Warning] baseURL defined more than once");
    }
    config.baseURL = baseURL;
  }
}
function concatBaseURL(uri, options) {
  var _a;
  if (options.baseURL) {
    return `${options.baseURL}${uri}`;
  }
  return `${(_a = config.baseURL) != null ? _a : ""}${uri}`;
}
function handleUriCreation(uri, options) {
  return isFullUri(uri) ? uri : concatBaseURL(uri, options);
}
function makeUri(uri, options = {}) {
  if (isFullUri(uri) || isRelativeUri(uri)) {
    return handleUriCreation(uri, options);
  }
  throw new Error(`[Http Exception] ${uri} is illegal`);
}

export { configure, handleUriCreation, makeUri };
